<template>
  <div class="box5" ref="box5Top">
    <div class="top-box">
      <pageTitle title="重点专业介绍" />  
      <div v-if="!isSticky" class="nav-box5">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': curTab == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
         
        </div>
      </div>
      <div v-if="isSticky" class="nav-box5 sticky">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': curTab == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
          
        </div>
      </div>
    </div>
    <div class="content">
      <div class="item">
        <div class="title">
          <img src="../../../assets/coursePage/mba/box5/icon01.png"/>
          <h1>专业详情</h1>
        </div>
        <p class="desc" v-if="curTab==0">金门大学的商科硕士项目的课程融合了核心商业知识和必要的软技能，如有效的沟通行政演讲和团队建设等，不仅提供了管理的综合视角，同时还包含大量的真实商业案例，致力于在职专业人士实现其职业目标培养学员的商业敏锐度、领导技能和专业背景。</p>
        <div class="subject-box">
          <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
            <swiper-slide
              class="swiperwrap"
              v-for="(item, index) in listSwiper"
              :key="index"
            >
              <div class="box">
                <img :src="item.img" alt="" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination-box2"></div>
        </div>
      </div>
      <div class="item">
        <div class="title">
          <img src="../../../assets/coursePage/mba/box5/icon02.png"/>
          <h1>课程内容</h1>
        </div>
        <p class="desc" v-if="curTab==0">MBA硕士项目毕业需完成10门课程的学习，共30学分</p>
        <p class="desc" v-else >MSAI硕士项目毕业需完成10门课程的学习，共30学分</p>
        <ul>
            <li v-for="(itemInner,indexInner) in list" :key="indexInner" :class="itemInner.isExpand?'current':''">
              <div class="title" @click="clickFn(itemInner,indexInner)">
                <div class="left">
                  <b>{{itemInner.title}}</b>
                  <i v-if="itemInner.title2">{{itemInner.title2}}</i>
                </div>
                <div class="right"  :class="{ 'img-rotate': itemInner.isExpand}">
                  <img
                    src="../../../assets/coursePage/ai/box6/icon-down.png"
                    alt
                  />
                </div>
              </div>
              <div class="content">
                <i>{{itemInner.txt}}</i>
              </div>
            </li>
           
          </ul>
      </div>
      <div class="item" v-if="curTab==0">
        <div class="title">
          <img src="../../../assets/coursePage/mba/box5/icon03.png"/>
          <h1>商科教授</h1>
        </div>
        <p class="desc">授课教授均是各自领域经验丰富的专业人士，拥有在旧金山湾区的成功企业工作的丰富经验，将为学员在当今复杂的商业环境中发挥领导作用做好充分，为学员提供成为优秀领导者所具备的洞察力。</p>
        <div class="wrapper">
          <img @click="clickTeacher(index)" v-for="(item,index) in imgList" :key="index" :src="item.img"/>
         
        </div>
      </div>
       <div class="item" v-else>
        <div class="title">
          <img src="../../../assets/coursePage/mba/box5/icon03.png"/>
          <h1>人工智能教授</h1>
        </div>
        <div class="top">
          <div class="top-teacher">
              <img src="../../../assets/coursePage/mba/box5/Zadeh.png"/>
              <span>
                <a>数据科学家<br/>哥伦比亚大学应用物理博士</a>
                <h1>Dr. Siamak<br/>Zadeh</h1>
              </span>
          </div>
          <p>Siamak教授现任金门大学副教授、人工智能硕士工作组主席、MSBA 硕士项目主任。<br/>
Siamak教授自2011年起于金门大学任教，专注于商业分析、人工智能、数据分析技术等学科教学与研究。在教学过程中，他将自身丰富的行业实战经验深度融入课程体系，通过真实商业案例分析与项目模拟，帮助学生掌握前沿技术的实际应用方法培养出众多能够将理论知识灵活运用于实践的复合型人才。<br/>
Siamak教授拥有超过30年的IT行业与学术界经验，曾在IBM研究院、Oracle 等多所全球顶尖科技机构担任高级研究与管理职务，擅长运用分析技术解决各类业务问题与挑战。</p>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ projectList[this.cur].title }}</div>
          <div class="close" @click="show = false"></div>
        </div>

        <div class="target">
          <p v-for="j in projectList[this.cur].arr" :key="j">{{ j }}</p>
        </div>
        <div class="intro">{{ projectList[this.cur].p }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
       navList: [
        {
          title: "工商管理硕士", 
        }, 
        {
          title: "人工智能硕士", 
         
        }, 
      ],
      curTab: 0,
      isSticky: false,
      show: false,
      curTab:0,
      cur:0,
      imgList: [
        {
          img: require("../../../assets/coursePage/mba/box5/teacher01.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/teacher02.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/teacher03.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/teacher04.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/teacher05.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/teacher06.png"),
        },
      ],
      projectList:[{
        title:'Bruce Magid 博士',
        arr:['商学院院长、教务长、高级副校长','美国塔夫茨大学博士、经济学、商法和比较政治学方向'],
        p:'Magid教授是一名教育家，经验丰富的大学管理者，是全球教育和商业领域方面的专家。具有独特的高等教育、私营部门和非营利机构工作经验，拥有广泛的商业研究经验。Magid教授在学术领导、全球商业和公共政策方面拥有非常丰富的经验。'
      },{
        title:'Joaquin Gonzalez 博士',
        arr:['金门大学国际学院院长','犹他大学博士，菲律宾大学公共管理硕士'],
        p:'Gonzalez教授现为金门大学国际学院院长，是公共政策方面的专家。Gonzalez博 士的研究得益于他在公共服务改革项目方面的丰富专业经验，他在多家世界级的公共机构任职技术顾问，曾五次获得卓越研究奖和四次获得卓越教学奖(GGU、NUS、USF) ,著有20本公共和城市事务书籍。'
      },{
        title:'Raymond Xia 博士',
        arr:['金门大学Global MBA教授','新西兰奥塔哥大学市场营销博士学位','硕士毕业于英国杜伦大学'],
        p:'Raymond教授拥有非常丰富的市场营销授课经验，多年来一直从事MBA、DBA市场营销课程的讲授，并在家电、IT产品和快消品等行业从事了超过10年的市场营销工作，历任红牛中国市场总监、海信品牌专家等职，拥有丰富的学术和行业相结合的经验.'
      },{
        title:'Tao Bai 博士',
        arr:['金门大学Global MBA教授','清华大学战略管理与商业政策博士','剑桥大学联合培养博士生学者'],
        p:'国际战略课程教授，曾在中国、澳大利亚和英国教授课程，授课方向主要包含:国际商务、国际运营、商业战略和中国经商等方面，授课对象涵盖本科生、研究生和各级企业管理人员，国际战略和商业战略领域专家.'
      },{
        title:'Xiao Wang 博士',
        arr:['金门大学Global MBA教授','荷兰格罗宁根大学与中国科学院大学双博士','国际高等教育学院高级院士、博士生导师','西浦国际商学院管理学硕士专业主任'],
        p:'具有丰富的人力资源、创新类课程授课经验，授课专业范畴:管理与领导力、设计驱动的创新和创业精神，技术创新和战略， 动态创新能力，创新和创业( 例如技术趋势、创新和社会价值创造，未来创业)'
      },{
        title:'Liyao Hou',
        arr:['金门大学Global MBA教授','清华大学自动化专业本科毕业','韩国POSETCH大学工业管理硕士'],
        p:'曾被评选为2014年度最佳分析师，在金融和投资领域具有超过16年的全球研究和投资经验，是多家财富500强公司、中国银行、中国人寿保险的特邀讲师。热门经济学著作《X时代的财富密码》作'
      }],
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 20,
        slidesPerView: "auto",
        autoplay: true,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      list:[],
      listTab1:[{
          title:'管理领导力',
          title2:'Management & Leadership',
          txt:'本课程着重于培养学生的领导力，帮助他们将领导力技能与岗位技术知识相结合并应用。课程首先从区分领导力和管理能力开始，随后从多个角度介绍领导力概念及其发展过程中的主要理论和模型，学生将了解不同领导情境下的决策过程。最后，课程将引导学生学习如何在管理岗位中，或即将步入的管理岗位中，展现出领导力。',
          isExpand:false,
        },{
          title:'组织团队合作',
          title2:'Teamwork in Organizations',
          isExpand:false,
          txt:'组织中的团队合作很重要，因为它能为员工提供互相建立联系的机会，改善员工之间的关系。这门课程会致力于研究有关于小组沟通的性质、发展与相关研究成果。课程主题涵盖多种组织环境下的领导力、人际关系与角色、目标与决策等实用内容。'
        },{
          title:'市场营销管理',
          title2:'Marketing Management',
          isExpand:false,
          txt:'本课程旨在让学生全面了解全球营销策略和相关实践应用。课程涵盖与全球营销相关的关键概念、理论和框架，重点关注在不同文化、经济和监管环境中开展营销活动时出现的挑战和机遇。学生将深入了全球营销的各个复杂方面，例如全球市场的进入、调研，以及产品的开发、品牌化、定价、分销渠道和促销策略等。'
        },{
          title:'战略分析与设计',
          title2:'Strategic Analysis and Design',
          isExpand:false,
          txt:'战略分析与设计课程旨在让学生全面了解，在全球范围内开展业务所涉及的原则和相关实践。课程会探讨国际商业战略的各个方面，包括全球市场动态、跨文化管理、国际贸易和投资、全球供应链管理和跨国商业战略。学生将深入了解并熟悉，在多元化的国际商务环境中展开经营时会面临的挑战和机遇。'
        },{
          title:'商业分析基础',
          title2:'Foundations of Business Analytics',
          isExpand:false,
          txt:'商业分析课程侧重于传授学生相关知识和技能，让他们能实现对商业数据的高效分析和解读，从而为决策提供信息。课程涵盖数据分析的各方面，包括数据的收集、清理、探索、可视化和统计分析。该课程还会探讨分析技巧在财务、营销、运营和战略等不同商业领域中的应用。学生将学习利用分析工具和相关技术从数据中提取出有价值的见解，并做出数据驱动的商业决策。'
        },{
          title:'商业法',
          title2:'Business Law',
          isExpand:false,
          txt:'商业法课程介绍了企业运营背景下的基本法律原则，重点关注影响全球企业运营的法定环境。该课程会将重点放在中国的商业和法律环境，但课程所培养出的批判性思维技能和资源参与能力也适用于其他司法管辖区。'
        },{
          title:'市场转型经济学',
          title2:'Economics of MarketplaceTransformation and Disruption',
          isExpand:false,
          txt:'经济学课程会基于资源的稀缺性，对主导人类行为和决策的基本原则和理论展开探讨。课程会深入研究各种经济主体，包括客户、员工、供应商、股东、政府实体和竞争对手，旨在深入了解他们的行为。课程会通过对各经济学话题的全面研究，来帮助学员了解从经济学家的视角，看待和分析世界的方式。'
        },{
          title:'信息科技',
          title2:'Information Technology',
          isExpand:false,
          txt:'信息科技在现代商业领域乃至整个社会中都发挥着至关重要的作用。本课程将概述，如何通过利用信息系统和技术，对各类业务流程和企业范围内的举措提供支持。课程涵盖的主题包括客户关系管理(CRM)、 企业资源规划(ERP)、 供应链管理(SCM)、 电子商务以及移动计算、云计算和社交网络等新兴技术。'
        },{
          title:'运营与供应链管理',
          title2:'Operations and Supply ChainManagement',
          isExpand:false,
          txt:'运营与供应链管理课程呈现的是对组织内管理运营所涉及的原则和实践的全面理解。课程涵盖流程分析、运营分析工具，以及影响组织层面运营的战略因素等多方面的内容。学生将深入了解运营管理会如何影响工作流程，并掌握推动公司综合表现达到世界级水平的秘诀。'
        },{
          title:'创业与创新',
          title2:'Entrepreneurship and New Business Development',
          isExpand:false,
          txt:'创业与创新课程会让学生全面了解实现成功创业和创新所需的知识和技能。课程聚焦于商业模式创新，并会为学生提供亲自参与创立初创企业的实践机会。通过实践练习和现实中的实操实验，结合真实的客户反馈和市场测试，学生将了解让商业创意从构想到落地市场的全流程。'
        }],
        listTab2: [
  {
    title: '人工智能基础',
    title2: 'Foundations of Artificial Intelligence',
    txt: '本课程全面介绍人工智能的核心概念，并重点探讨其在商业领域的应用。课程既涵盖AI技术原理，又深入解析AI如何重塑行业格局。学生将系统学习机器学习、自然语言处理与决策算法等核心方法，通过真实商业案例评估AI应用的伦理问题与落地挑战。',
    isExpand: false,
  },
  {
    title: '人工智能的生态系统',
    title2: 'Artificial Intelligence Ecosystem',
    txt: '本课程深入探讨人工智能的支撑生态系统，重点研究AI与大数据、物联网(IoT)、机器人技术、云计算、边缘计算及网络安全等关联技术的协同关系，并将系统分析这些技术组件如何共同驱动跨行业的智能系统。',
    isExpand: false,
  },
  {
    title: '人工智能的伦理、治理与安全',
    title2: 'AI Ethics, Governance & Security',
    txt: '随着AI技术的深度渗透，关于责任归属、算法透明度、系统偏见、数据安全与技术管控等问题变得愈发紧迫，本课程将系统研究人工智能在现代社会中的伦理规范、社会影响、监管框架与治理体系。',
    isExpand: false,
  },
  {
    title: '提示词工程与验证',
    title2: 'Prompt Engineering and Validation',
    txt: '本课程深入探讨提示工程(prompt engineering)这一新兴学科，重点研究如何设计与优化输入指令以有效引导生成式AI系统的行为。随着此类系统日益深度集成到产品、工作流及决策环节中，与之高效沟通的能力已成为关键的技术与战略技能。',
    isExpand: false,
  },
  {
    title: '机器学习与预测分析',
    title2: 'ML & Predictive Analytics',
    txt: '本课程深入探讨机器学习(ML)与预测分析在现代商业环境中的原理、方法及应用。课程专为商业及数据驱动型专业人士设计，致力于弥合复杂机器学习算法与其在市场营销、财务运营、人力资源及客户体验等领域的战略价值之间的鸿沟。',
    isExpand: false,
  },
  {
    title: '智能体AI',
    title2: 'Agentic AI',
    txt: '本课程深入探讨快速发展的智能体人工智能（Agentic AI）领域，重点研究具备环境感知、自主决策和目标执行能力的AI智能体（自主/半自主系统）的应用。课程将系统讲解智能体的核心构成要素，包括：环境感知、逻辑推理、目标制定、行动规划、记忆存储、持续学习。',
    isExpand: false,
  },
  {
    title: '商业中的高级人工智能',
    title2: 'Advanced AI for Business',
    txt: '本课程探讨人工智能作为变革性驱动力在现代商业中的战略价值。通过概念框架、案例研究和实践洞察的结合，学生将探索人工智能技术如何重塑竞争格局、重新定义价值链并赋能全新的商业生态。学生将分析人工智能在核心业务职能中的应用，评估采用人工智能的战略意义，并学习如何构建负责任且有效地利用人工智能的创新战略。',
    isExpand: false,
  },
  {
    title: '服务业中的人工智能',
    title2: 'AI in Service Industries',
    txt: '本课程系统研究人工智能如何驱动服务行业的颠覆性变革与创新，随着AI技术能力的快速演进，服务行业正经历着从客户交互模式、资源管理机制到价值交付体系、运营规模扩展和服务创新生态的全方位重构与升级。',
    isExpand: false,
  },
  {
    title: '制造业中的人工智能',
    title2: 'AI in Manufacturing and Goods-Producing Industries',
    txt: '本课程系统研究人工智能在工业4.0背景下对制造业及实体产品生产行业的全方位变革与创新驱动。随着制造企业面临提升生产效率、增强运营敏捷性和实现可持续发展的多重压力，从机器学习、计算机视觉到数字孪生和预测性维护等一系列AI技术，正在深刻重塑从供应链管理、质量控制、设备监测到生产规划、物流优化和产品设计等价值链各环节的创新实践。',
    isExpand: false,
  },
  {
    title: '顶点课程',
    title2: 'Capstone',
    txt: '顶点课程将为学生提供机会，整合并运用在整个项目中获得的知识、工具和策略，完成一个综合性、真实的人工智能项目，该项目旨在帮助学员通过人工智能应对商业中的各种困难与挑战。',
    isExpand: false,
  }
],
      listSwiper: [
        {
          img: require("../../../assets/coursePage/mba/box5/img01.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box5/img02.png"),
        }
      ]  
    };
  },
  created(){
    this.list=this.listTab1
  },
  mounted() {
    this.$nextTick(()=>{
      window.scrollTo({
        top: 0
      });
    })
   window.addEventListener('scroll', this.handleScroll);
   
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
     changeCur(index) {
      this.curTab = index;
      if(index==0){
        this.list=this.listTab1
      }else{
        this.list=this.listTab2
      }
      // 获取 nav-box5 元素
      const navBox = this.$el;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (navBox) {
        // 获取 nav-box5 元素的顶部位置
        const navBoxTop = navBox.getBoundingClientRect().top + scrollTop + 60;
        // 滚动到 nav-box5 元素的位置
        window.scrollTo({
          top: navBoxTop,
          behavior: 'smooth' // 平滑滚动
        });
      }
    },
     handleScroll() {
      // 获取  .box5 元素
      const box5 = this.$refs.box5Top;
   
      //获取滚动高度
      const scrollHeight =
      document.body.scrollTop||document.documentElement.scrollTop;
      if(box5.offsetTop+80<scrollHeight && scrollHeight<box5.offsetTop+box5.offsetHeight){
         this.isSticky =true
      }else{
         this.isSticky =false
      }
      
    },
    clickTeacher(index){
      this.cur=index
      this.show=true
    },
    clickTab(index){
      this.curTab=index
    },
    clickFn(item,index){
      this.list.forEach((item,i)=>{
        if(index!=i){
          item.isExpand=false
        }
      })
      this.list[index].isExpand=!this.list[index].isExpand
    }
  },
};
</script>

<style lang="less" scoped>
.box5 {
  position: relative;
  padding: 80px 0 80px;
  background: #FFFFFF; 
  .content{
    padding: 0 32px;
  }
  .top-box {
    box-sizing: border-box;
    padding: 60px 0 0;
    width: 100%;
    height: 218px;
    background: url("../../../assets/coursePage/mba/box5/bg.png") no-repeat;
    background-size: cover;
    /deep/.course-title-box{
      .course-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 44px;
        color: #FFFFFF;
      
      }
      .course-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 52px;
      }
    } 
    .nav-box5 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 64px;
    margin: 36px auto 0;
    will-change: position;
    // transition: all 1s ease-in-out;
    .nav {
      cursor: pointer;
      box-sizing: border-box;
      width: 50%;
     
      text-align: center;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      h3 {
        font-size: 34px;
        line-height: 48px;
      }
      p {
        margin-top: 2px;
        width: 300px;
        font-size: 20px;
        line-height: 20px;
        color: rgba(255,255,255,0.5);
      }
    }
    .cur-nav {
      position: relative;
      &::after {
        position: absolute;
        content: '';
        bottom: -15px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 218px;
        height: 14px;
        background: url("../../../assets/coursePage/stevens/box5/selected.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .sticky {
    height: 100px;
    margin: 0;
    padding-top: 26px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #E65A2E; 
    -webkit-transform: translateZ(0); // 开启硬件加速
    transform: translateZ(0);
    will-change: position; // 提前告知浏览器位置即将变化
    transition: none; // 去除过渡效果
    box-sizing: border-box;
    .cur-nav {
      &::after {
        bottom: -10px; 
      }
    }
  }
  }
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 56px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
   
    .intro {
      font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 26px;
color: #4E5969;
line-height: 44px;
text-align: left;
font-style: normal;
margin-bottom: 128px;
    }

   


    .target {
      margin-bottom: 32px;
    
      p {
         padding:0 16px;
         
          height: 44px;
background: #FFF7E8;
border-radius: 8px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 24px;
color: #FF7D00;
line-height: 44px;
text-align: left;
font-style: normal;
margin-bottom: 16px;
display: inline-block;
      }
      p:last-child{
        margin-bottom: 0;
      }
    }
  }
  >.content{
    margin-top: 84px;
    .item{
      position: relative;
      margin-bottom: 84px;
      background: linear-gradient( 163deg, #FFFFFF 0%, #FFF9F5 33%, #FFFFFF 100%);
      box-shadow: inset 0px 0px 24px 0px rgba(255,219,194,0.41);
      border-radius: 44px;
      border: 2px solid rgba(255, 202, 166, 1);
      padding: 68px 0  32px;
      >.top{
         background: #FFFFFF;
          box-shadow: 0px 12px 32px 0px #F4EDEA;
          border-radius: 26px;
          padding:40px;
          margin: 0 32px;
          .top-teacher{
             display: flex;
            justify-content: space-between;
            align-items: center;
            img{
              width: 216px;
              margin-right: 32px;
            }
          span{
            a{
              font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 26px;
                color: #D6613C;
                line-height: 44px;
                text-align: left;
                font-style: normal;
                margin-bottom: 8px;
                white-space: nowrap;
            }
            h1{
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 40px;
              color: #272020;
              line-height: 52px;
              text-align: left;
              font-style: normal;
            }
          }
        
          }
          p{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #3C3937;
            line-height: 40px;
            text-align: justify;
            font-style: normal;
            margin-top: 24px;
          }
      }
      >.title{
        position: absolute;
        left: 50%;
        top: -36px;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 328px; 
        height: 72px;
        background:linear-gradient( 270deg, #E2895E 0%, #E65A2E 100%);
        border-radius: 36px;
        img{
          width: 64px;
          height: 64px; 
          margin-right: 16px;
        }
        h1{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 28px;
          color: #FFFFFF;
          line-height: 40px;
          text-align: center;
          font-style: normal;
        }
      }
    }
    .item:last-child{
      margin-bottom: 0;
    }
    .wrapper{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding:0 32px;
      margin-bottom: -20px;
      img{
        width: 298px;
        margin-bottom: 20px;
      }
    }
    .desc{
      font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #3C3937;
        line-height: 40px;
        text-align: justify;
        font-style: normal;
        padding:0 32px;
        margin-bottom: 24px ;
    }
    ul {
          margin-top: 24px;
          padding: 0 32px;
          .current{
           
            height:auto !important
          }
          
          li {
            margin-top: 20px;
            background: #ffffff;
            box-shadow: 0px 12px 32px 0px #F4EDEA;
            border-radius: 16px;
            overflow: hidden;
            padding: 0 24px;
            height: 126px;
            transition: 0.5s ease all;
            .title {
              padding: 26px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .left {
                b {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 28px;
                  color: #3C3937;
                  line-height: 44px;
                  text-align: left;
                  font-style: normal;
                  display: block;
                }
                i{
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 20px;
                  color: #8F8B89;
                  line-height: 32px;
                  text-align: left;
                  font-style: normal;
                }
              }
              .right {
                width: 28px;
                height: 28px;
                transition: 0.5s ease all;
                margin-right: 5px;
                img {
                  width: 100%;
                  height: 100%;
                }
                
              }
              .img-rotate{
                transition: 0.5s ease all;
              transform: rotate(180deg);
              }
            }
            .content {
              padding: 36px 0 24px;
              border-top: 2px solid #f2f3f5;
             
              >i {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #3C3937;
                line-height: 40px;
                text-align: left;
                font-style: normal;
              }
              
            }
          }
        }
  }
  .subject-box {
    position: relative;
    margin: 0 auto 0;
    // padding-bottom: 22px;
    
    width: calc(100%);
    overflow: hidden;
    border-radius: 20px;
    overflow: hidden;
    .swiper-slide {
     
      border-radius: 20px;
    }

    .swiper-pagination-box2 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      height: 6px;
     
    }

    /deep/ .swiper-pagination-bullet {
    width: 12px;
    height: 6px;
    background: #FBD3C6;
    border-radius: 3px;
    margin-right: 8px;
    opacity: 1;
  }
  /deep/ .swiper-pagination-bullet:last-child {
    margin-right: 0px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 24px;
height: 6px;
background: #E55A2E;
border-radius: 3px;
  }

    .swiper-slide {
      width: 100%;
      display: flex;
      justify-content: center;

      box-sizing: border-box;
      .box {
       
        width:100%;
        // height: 512px;
        img {
          width: 100%;
          
        }
        
      }
     
    }
  }
}
</style>
